/**
 * Created by JackCui on 2021/12/2
 */

import labelPosition from './label-position'
import thousandsInput from './thousands-input'
import fieldPrecision from './field-precision'
import upload from './upload'

export default {
  labelPosition,
  thousandsInput,
  fieldPrecision,
  upload
}
